import { FormControl } from '@angular/forms';
import { GenderCode, SpeciesCode, LifestageType, ReproductionStatusCode } from '@app/shared/utils';
import { AgeUnitsEnum } from '@app/shared/utils/enums/age-unit.enum';
import { Sterilization } from '@app/shared/utils/types/sterilization.enum';

export enum PetProfileFormValueKeys {
  PET_FINDER = 'petFinder',
  NAME = 'name',
  SPECIES_CODE = 'speciesCode',
  GENDER = 'gender',
  NEUTERED = 'neutered',
  NEUTERED_TODAY = 'neuteredToday',
  STERILIZATION_TYPE = 'sterilizationType',
  REPRODUCTION_STATUS = 'reproductionStatus',
  BREED_PICKER = 'breedPicker',
  BREED = 'breed',
  MIXED_BREED = 'mixedBreed',
  MIXED = 'mixed',
  BIRTHDATE = 'birthdate',
  PET_ACTIVITY = 'petActivity',
  LIFESTAGE = 'lifestage',
  UNKNOWN_BIRTHDATE = 'unknownBirthdate',
  AGE_COUNTER = 'ageCounter',
  AGE_UNIT = 'ageUnit',
  WEEKS_OF_PREGNANCY = 'pregnancyWeeks',
  CURRENT_WEIGHT = 'currentWeight',
  TARGET_WEIGHT = 'targetWeight',
  BCS = 'bcs',
  IS_WLP_INCLUDED = 'isWLPIncluded',
  NEXT_VISIT_DATE = 'nextVisitDate',
}

export interface PetProfileFormValues {
  name: string;
  gender: GenderCode;
  speciesCode: SpeciesCode;
  breed: string;
  birthdate: Date;
  unknownBirthdate: UnknownBirthdate; // used only for UI
  mixed: boolean;
  neutered: boolean;
  neuteredToday: boolean;
  sterilizationType: Sterilization;
  reproductionStatus: ReproductionStatusCode;
  pregnancyWeeks: number | null;
  lifestage: LifestageType;
}

export interface LifestageInfo {
  code: LifestageType | null;
  message: string | null;
  error: string | null;
}

export interface BirthdateGroupFormValues {
  birthdate: Date | null;
  unknownBirthdate: boolean;
  ageCounter: number;
  ageUnit: AgeUnitsEnum;
}

export interface UnknownBirthdate {
  isUnknown: boolean;
  ageCounter: number;
  ageUnit: AgeUnitsEnum;
}

export enum PET_PROFILE_NOTIFICATION_ID {
  WM_LIFESTAGE = 'wmLifestageAlert',
  WM_REPRODUCTION_STATUS = 'wmReproductionStatusAlert',
  RD_SPECIE_BIRTHDATE = 'rdSpecieBirthdateAlert',
}

export interface BreedPickerGroup {
  breed: FormControl<string>;
  mixed: FormControl<boolean>;
  mixedBreed: FormControl<string>;
}
